import { SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ProjectIcon } from '../../project-icon/project-icon.component';
import { ResultIdentity } from './result-identity.component';
import { ResultItemRow } from './result-item-row.component';
import { dataString } from '../search.utils';
import { convertHyphenated } from '../../../../../core/util/string-conversion';

export function ProjectResultItem({
  item,
  href,
  onClick
}: {
  item: SearchResultItemDto;
  href?: string;
  onClick?: () => void;
}) {
  // Project type + shortcode — gives address-less projects (e.g. retailers) useful detail too.
  const typeLabel = item.subType ? convertHyphenated(item.subType, { capitalizeEachWord: true }) : undefined;
  const shortcode = dataString(item.data, 'shortcode');
  const typeLine = [typeLabel, shortcode].filter(Boolean).join(' · ') || undefined;

  const street =
    [dataString(item.data, 'addressLine1'), dataString(item.data, 'addressLine2')].filter(Boolean).join(', ') ||
    undefined;
  const locality =
    [
      dataString(item.data, 'addressSuburb'),
      dataString(item.data, 'addressState'),
      dataString(item.data, 'addressPostcode')
    ]
      .filter(Boolean)
      .join(' ') || undefined;

  // Flag non-active (e.g. inactive) projects, matching the person-row treatment.
  const status = dataString(item.data, 'status');
  const tag = status && status !== 'active' ? convertHyphenated(status, { capitalizeEachWord: true }) : undefined;

  const projectImageURL = dataString(item.data, 'projectImageURL');
  const trailing = projectImageURL ? <ResultIdentity imageURL={projectImageURL} /> : undefined;

  return (
    <ResultItemRow
      icon={<ProjectIcon projectType={item.subType} />}
      primary={item.label}
      secondaryLines={[typeLine, street, locality]}
      tag={tag}
      trailing={trailing}
      href={href}
      onClick={onClick}
    />
  );
}
